import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as AuditTrailActions from './audit-trail.action';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { AuditTrailManagementService } from '../services/audit-trail-management.service';

@Injectable()
export class AuditTrailEffects {
    private actions$ = inject(Actions);
    private AuditTrailManagementService = inject(AuditTrailManagementService);

    findAuditTrails$ = createEffect(() => this.actions$.pipe(
        ofType(AuditTrailActions.findAuditTrails),
        mergeMap(payload => this.AuditTrailManagementService
            .findAuditTrails(payload.page, payload.size, payload.keywords, payload.action, payload.excludeAction, payload.username).pipe(
                map(auditTrails => AuditTrailActions.findAuditTrailsSuccess({ auditTrails })),
                catchError(error => of(AuditTrailActions.findAuditTrailsError({ error })))
            )
        )
    ));

}
